import {
  hasPerformanceMark,
  sendNavigationVitalOnce,
  warnMeasureFailed,
  wasNavigationVitalSent,
} from 'features/monitoring/performanceMonitor';

const FIRST_QUESTION_BLOCKED_MARK = 'firstQuestionBlocked';

const canSendFirstQuestionVital = (): boolean =>
  wasNavigationVitalSent('startFlow') &&
  !hasPerformanceMark(FIRST_QUESTION_BLOCKED_MARK);

const isFirstQuestionVitalPending = (): boolean =>
  !wasNavigationVitalSent('firstQuestion') && canSendFirstQuestionVital();

/**
 * Keeps the `firstQuestion` vital of this page load from sending. Every screen
 * a start can show other than a questionnaire page or summary calls it.
 */
export const blockFirstQuestionVital = (): void => {
  try {
    if (
      hasPerformanceMark(FIRST_QUESTION_BLOCKED_MARK) ||
      wasNavigationVitalSent('firstQuestion')
    ) {
      return;
    }
    performance.mark(FIRST_QUESTION_BLOCKED_MARK);
  } catch (error) {
    warnMeasureFailed('firstQuestion', error);
  }
};

/**
 * Sends the `firstQuestion` vital in a task posted from the next animation
 * frame, so it ends after that frame paints. Returns the cancel.
 */
export const scheduleFirstQuestionVital = (): (() => void) => {
  try {
    if (!isFirstQuestionVitalPending()) return () => undefined;
  } catch (error) {
    warnMeasureFailed('firstQuestion', error);
    return () => undefined;
  }
  let task: ReturnType<typeof setTimeout> | undefined;
  const frame = requestAnimationFrame(() => {
    task = setTimeout(() => {
      sendNavigationVitalOnce('firstQuestion', canSendFirstQuestionVital);
    }, 0);
  });
  return () => {
    cancelAnimationFrame(frame);
    clearTimeout(task);
  };
};
